export const legalContent = {
    es: {
        breadcrumbHome: 'Inicio',
        contactSectionTitle: 'Contáctanos',
        contactIntro: 'Para cualquier pregunta sobre esta política de privacidad o para ejercer tus derechos, puedes contactarnos a través de:',
        emailLabel: 'Email: contact@liguee1.com',
        whatsappLabel: 'WhatsApp:',
        whatsappCta: 'Haz clic aquí para contactarnos',
        conclusion: 'Gracias por elegir LIGUEE1. Nos enorgullece garantizar tu privacidad y ofrecerte un servicio de alta calidad sin comprometer tu seguridad ni tu anonimato.',
        privacy: {
            pageTitle: 'Política de Privacidad',
            sections: [
                {
                    title: '1. Información que recopilamos',
                    body: 'Recopilamos la información que nos proporcionas directamente, como tu nombre, dirección de email e información de pago cuando te suscribes a nuestros servicios IPTV. Esta información es necesaria para prestar nuestros servicios y procesar tus pagos.',
                },
                {
                    title: '2. Cómo utilizamos tu información',
                    body: 'Utilizamos tu información para prestar, mantener y mejorar nuestros servicios IPTV, procesar tus pagos, comunicarnos contigo sobre tu cuenta y enviarte actualizaciones importantes sobre nuestros servicios.',
                },
                {
                    title: '3. Cómo compartimos tu información',
                    body: 'No vendemos, intercambiamos ni alquilamos tu información personal a terceros. Solo podemos compartir tu información con nuestros proveedores de servicios de pago para procesar tus transacciones, y únicamente en la medida necesaria.',
                },
                {
                    title: '4. Seguridad de tus datos',
                    body: 'Aplicamos medidas de seguridad adecuadas para proteger tu información personal frente al acceso no autorizado, la modificación, la divulgación o la destrucción. Tus datos se cifran y se almacenan de forma segura.',
                },
                {
                    title: '5. Tus derechos',
                    body: 'Tienes derecho a acceder, corregir o eliminar tu información personal en cualquier momento. También puedes oponerte al tratamiento de tus datos o solicitar la portabilidad de tu información.',
                },
            ],
        },
        terms: {
            pageTitle: 'Términos y Condiciones de Uso',
            sections: [
                {
                    title: '1. Aceptación de las condiciones',
                    body: 'Al acceder a nuestro sitio web y utilizar nuestros servicios IPTV, aceptas los presentes Términos y Condiciones de Uso. Si no estás de acuerdo con estas condiciones, por favor no utilices nuestro sitio ni nuestros servicios.',
                },
                {
                    title: '2. Servicios IPTV',
                    body: 'LIGUEE1 ofrece suscripciones IPTV para que disfrutes de una gran variedad de canales y contenidos. Estas suscripciones están diseñadas para ofrecer una experiencia de visualización de calidad sin necesidad de recopilar tus datos personales.',
                    body2: 'Los códigos de activación y las instrucciones de instalación te serán enviados inmediatamente después de tu compra.',
                },
                {
                    title: '3. Privacidad',
                    body: 'No recopilamos ningún dato personal de nuestros usuarios. Esto significa que tu nombre, dirección, información de pago o cualquier otro dato identificable no son recopilados ni almacenados por LIGUEE1. Tu privacidad está garantizada y hemos implementado medidas para impedir cualquier recopilación de datos por parte de terceros.',
                    body2: 'Al utilizar nuestros servicios, puedes estar seguro de que tu actividad permanece totalmente anónima y segura.',
                },
                {
                    title: '4. Pago',
                    body: 'Los pagos se realizan a través de plataformas seguras de terceros. LIGUEE1 no almacena ninguna información de pago. Sigue las instrucciones proporcionadas para completar tu compra de forma segura.',
                },
                {
                    title: '5. Uso de los servicios',
                    body: 'Los servicios IPTV proporcionados por LIGUEE1 están destinados únicamente a un uso personal. No debes compartir, redistribuir ni revender los códigos de activación ni el contenido proporcionado por nuestros servicios. Cualquier uso indebido puede provocar la cancelación de tu suscripción sin reembolso.',
                },
                {
                    title: '6. Responsabilidad',
                    body: 'LIGUEE1 se compromete a ofrecer servicios IPTV de alta calidad. Sin embargo, no podemos garantizar una disponibilidad ininterrumpida debido a factores externos como cortes de Internet o problemas técnicos. Declinamos toda responsabilidad por interrupciones ajenas a nuestro control.',
                },
                {
                    title: '7. Derechos de propiedad intelectual',
                    body: 'Todo el contenido proporcionado por nuestros servicios IPTV, incluidos los canales, las películas y las series, está protegido por derechos de autor y leyes de propiedad intelectual. No debes grabar, distribuir ni copiar este contenido.',
                },
                {
                    title: '8. Modificaciones de las condiciones',
                    body: 'Nos reservamos el derecho de modificar estas condiciones en cualquier momento. Cualquier modificación se publicará en nuestro sitio web. Si continúas utilizando nuestros servicios después de una modificación, aceptas las nuevas condiciones.',
                },
            ],
        },
        refund: {
            pageTitle: 'Política de Reembolso',
            sections: [
                {
                    title: '1. Derecho al reembolso',
                    body: 'En LIGUEE1 nos comprometemos a garantizar tu satisfacción. Por ello, ofrecemos una política de reembolso de 15 días para todos nuestros usuarios. Si, por cualquier motivo, no estás satisfecho con nuestros servicios, puedes solicitar un reembolso dentro de los 15 días posteriores a tu compra.',
                },
                {
                    title: '2. Condiciones de reembolso',
                    intro: 'Para tener derecho a un reembolso, deben cumplirse las siguientes condiciones:',
                    list: [
                        'La solicitud debe realizarse dentro de los 15 días posteriores a la fecha de compra.',
                        'Debes aportar una prueba de compra válida, como tu recibo o tu email de confirmación.',
                        'Los reembolsos no están disponibles si ya has utilizado más del 50% de tu período de suscripción.',
                    ],
                },
                {
                    title: '3. Proceso de solicitud',
                    intro: 'Para solicitar un reembolso, sigue estos pasos:',
                    orderedList: [
                        'La solicitud debe realizarse dentro de los 15 días posteriores a la fecha de compra.',
                        'Debes aportar una prueba de compra válida, como tu recibo o tu email de confirmación.',
                        'Los reembolsos no están disponibles si ya has utilizado más del 50% de tu período de suscripción.',
                    ],
                },
                {
                    title: '4. Método de reembolso',
                    body: 'Si tu solicitud de reembolso es aprobada, el importe se devolverá mediante el mismo método de pago utilizado en tu compra. El plazo de tramitación puede variar según tu proveedor de pago.',
                },
            ],
        },
    },
};
